<div class="full">
    <ng-content select=".full"></ng-content>
</div>
<div class="left">
    <ng-content select=".left"></ng-content>
</div>
<div class="right">
    <ng-content select=".right"></ng-content>
</div>